import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Store } from "../Store";
import { api } from "../Api";
import ProfileCard from "../component/ProfileCard";

const generationLabel = (gen) => {
  if (gen === 1) return "First";
  if (gen === 2) return "Second";
  if (gen === 3) return "Third";
  if (gen === 4) return "Fourth";
  if (gen === 5) return "Fifth";
  return `Generation ${gen}`;
};

function groupBySource(rows = []) {
  const grouped = new Map();
  rows.forEach((row) => {
    const sourceUser = row.withdrawId && typeof row.withdrawId === "object" ? row.withdrawId : null;
    const key = `${row.generation}-${row.withdrawUsername || sourceUser?.username || row.withdrawId || row._id}`;
    const existing = grouped.get(key);
    const amount = Number(row.amount || 0);
    if (existing) {
      existing.amount += amount;
      existing.count += 1;
      existing.latestStatus = row.status || existing.latestStatus;
      return;
    }
    grouped.set(key, {
      ...row,
      amount,
      count: 1,
      withdrawId: sourceUser || row.withdrawId,
      sourceWithdrawAmount: Number(row.sourceWithdrawAmount || row.sourceWithdrawId?.grossAmount || 0),
      latestStatus: row.status || "Pending",
    });
  });
  return Array.from(grouped.values());
}

export default function IncomeGenerationHistory() {
  const navigate = useNavigate();
  const { state } = useContext(Store);
  const { userInfo } = state;
  const { id } = useParams();
  const gen = Number(id);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError("");
        const { data } = await axios.get(
          api + `/api/users/getIncomeGenerationHistory?generation=${gen}&pageSize=100`,
          {
            headers: { Authorization: `Bearer ${userInfo.token}` },
          }
        );
        setHistory(groupBySource(data.history || []));
      } catch (err) {
        setError("Could not load Income Generation history. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [gen, userInfo.token]);

  return (
    <div>
      <Helmet>
        <title>Income Generation History</title>
      </Helmet>
      <Container className="no-gutter">
        <div className="card">
          <Row>
            <Col style={{ textAlign: "center" }}>
              <img
                src="https://res.cloudinary.com/dddogyqqa/image/upload/v1670435815/logo/clickcart-logo_wfktlg.png"
                style={{ width: "15rem", margin: "2rem" }}
                alt="ClickCart Logo"
              />
            </Col>
          </Row>
          <div className="card-header" onClick={() => navigate("/selectgeneration")}>
            <i className="fa fa-long-arrow-left" aria-hidden="true"></i> Income Generation History
          </div>

          <div className="card mt-2" style={{ width: "80%", margin: "auto" }}>
            <div className="card-header">{generationLabel(gen)} Generation</div>
            <div className="card-body">
              {loading ? (
                <div className="text-center p-4">
                  <Spinner animation="border" size="sm" /> Loading history...
                </div>
              ) : error ? (
                <Alert variant="danger">{error}</Alert>
              ) : history.length === 0 ? (
                <Alert variant="info">No Income Generation history found for this generation.</Alert>
              ) : (
                <div className="row">
                  {history.map((item) => (
                    <ProfileCard key={`${item.generation}-${item.withdrawUsername}-${item._id}`} {...item} token={userInfo.token} />
                  ))}
                </div>
              )}
            </div>
          </div>

          <div style={{ height: "51vh" }}> {""}</div>
        </div>
      </Container>
    </div>
  );
}
